import Http from '@/utils/http'
const baseUrl = '/app/student'

/**
 * 错题列表
 * @param params
 * 
*/

export const wrongList = params => Http.get(`${baseUrl}/error/question`, { params })
